import React from "react";
import PropTypes from "prop-types";
import { Tag } from "antd";
import moment from "moment";
import "../../styles/Component/Chat/ExtractedDataPanel.css";

const dataTypeColors = {
  credentials: "red",
  password: "red",
  ssn: "orange",
  "social security": "orange",
  address: "blue",
  email: "cyan",
  phone: "green",
  "credit card": "magenta",
  "bank account": "volcano",
  dob: "purple",
  "date of birth": "purple",
  name: "geekblue",
  default: "default",
};

const getTagColor = (dataType) => {
  const key = dataType?.toLowerCase() || "";
  for (const [pattern, color] of Object.entries(dataTypeColors)) {
    if (key.includes(pattern)) {
      return color;
    }
  }
  return dataTypeColors.default;
};

const ExtractedDataPanel = ({ extractedData }) => {
  return (
    <div className="extracted-data-panel">
      <h6 className="extracted-data-title">Extracted Data</h6>
      {extractedData && extractedData.length > 0 ? (
        <div className="extracted-data-list">
          {extractedData.map((item, index) => (
            <div key={index} className="extracted-data-card">
              <Tag color={getTagColor(item.dataType)} className="extracted-data-tag">
                {item.dataType}
              </Tag>
              <p className="extracted-data-value">{item.value}</p>
              <span className="extracted-data-time">
                {moment(item.extractedAt).format("MMM D, YYYY h:mm A")}
              </span>
            </div>
          ))}
        </div>
      ) : (
        <p className="text-muted text-center text-sm mt-4">No data extracted yet</p>
      )}
    </div>
  );
};

ExtractedDataPanel.propTypes = {
  extractedData: PropTypes.arrayOf(
    PropTypes.shape({
      dataType: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
      extractedAt: PropTypes.string,
    })
  ).isRequired,
};

export default ExtractedDataPanel;
